.reveal {
  opacity: 0;
  transform: translateY(1rem);
  transition: opacity 600ms ease, transform 600ms cubic-bezier(0.22, 1, 0.36, 1);
}

.reveal[data-shown='true'] {
  opacity: 1;
  transform: none;
}

/* Belt and braces: if motion is reduced, never hide content even pre-hydration. */
@media (prefers-reduced-motion: reduce) {
  .reveal {
    opacity: 1;
    transform: none;
  }
}
